module.exports = __webpack_public_path__ + "img/图层 6 拷贝 3.1bd75452.png";